import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ReactTooltip from 'react-tooltip'

import './CheckboxGroup.sass'


class CheckboxGroup extends Component {
  constructor() {
    super()
    this._onCheckboxChange = this.onCheckboxChange.bind(this)
  }

  onCheckboxChange(e) {
    const { activeFilterIds, setActiveFilterIds, onUpdate } = this.props
    const filterTermId = parseInt(e.target.value)

    if (e.target.checked) {
      // Add to answers list
      const updatedFilterIds = [...activeFilterIds, filterTermId]
      setActiveFilterIds(updatedFilterIds)
      onUpdate(updatedFilterIds)
    } else {
      // Remove from answers list
      const updatedFilterIds = activeFilterIds.filter(a => a !== filterTermId)
      setActiveFilterIds(updatedFilterIds)
      onUpdate(updatedFilterIds)
    }
  }

  render() {
    const {
      options,
      activeFilterIds,
      containerClassName,
      checkboxClassName,
      isFilteredSearch
    } = this.props

    return (
      <fieldset className={containerClassName}>
        { options.map((option, idx) => (
          <div key={idx} className={`checkbox ${checkboxClassName}`}>
            <input
              type="checkbox"
              checked={activeFilterIds.includes(option.id)}
              aria-selected={activeFilterIds.includes(option.id)}
              onChange={this._onCheckboxChange}
              id={option.id}
              value={option.id}
            />
            <label htmlFor={option.id}>{option.name}</label>
            {/* tooltip */}
            { (!isFilteredSearch && option.meta && option.meta.tooltip) &&
              <div style={{ display: 'inline-block' }}>
                <a
                  className="tooltip-sm checkbox-tooltip"
                  data-tip
                  data-for={option.name}
                  data-iscapture="true"
                >
                  ?
                </a>
                <ReactTooltip
                  id={option.name}
                  place="bottom"
                  effect="solid"
                  class="tooltip-theme"
                >
                  <span>{option.meta.tooltip}</span>
                </ReactTooltip>
              </div>
            }
          </div>
        ))}
      </fieldset>
    )
  }
}

CheckboxGroup.propTypes = {
  options: PropTypes.array,
  setActiveFilterIds: PropTypes.func,
  activeFilterIds: PropTypes.array,
  onUpdate: PropTypes.func,
  containerClassName: PropTypes.string,
  checkboxClassName: PropTypes.string,
  isFilteredSearch: PropTypes.bool
}

CheckboxGroup.defaultProps = {
  onUpdate: () => {},
  containerClassName: 'checkbox-group',
  checkboxClassName: 'checkbox-radio-green',
  isFilteredSearch: false
}

export default CheckboxGroup
